import { SectionType } from '../../types';
export function fixTopSpacingOnMobile(sections) {
    const firstSection = sections[0];
    if (firstSection.type === SectionType.topSpacer) {
        return handleFirstSection([
            firstSection.height,
            sections[1]?.outerPadding?.top || 0,
            sections[1]?.innerPadding?.top || 0,
        ]);
    }
    else {
        return handleFirstSection([
            sections[0]?.outerPadding?.top || 0,
            sections[0]?.innerPadding?.top || 0,
        ]);
    }
}
function calculateMobileTopSpacingProportion(paddings) {
    const maxMobileTopSpace = 40;
    const desktopTopSpace = sum(paddings);
    if (desktopTopSpace <= maxMobileTopSpace) {
        return paddings;
    }
    const newPaddings = paddings.map((pad) => Math.floor((maxMobileTopSpace * pad) / desktopTopSpace));
    newPaddings[newPaddings.length - 1] =
        maxMobileTopSpace -
            (sum(newPaddings) - newPaddings[newPaddings.length - 1]);
    return newPaddings;
}
function handleFirstSection(spacings) {
    const smallerSpacings = calculateMobileTopSpacingProportion(spacings);
    const lastIndex = smallerSpacings.length - 1;
    return {
        margin: sum(smallerSpacings.slice(0, lastIndex)),
        padding: smallerSpacings[lastIndex],
    };
}
function sum(array) {
    return array.reduce((acc, x) => acc + x, 0);
}
//# sourceMappingURL=css-utils-top-padding.js.map